import { render, staticRenderFns } from "./B2BEmpresaModal.vue?vue&type=template&id=2ad5c80e&scoped=true"
import script from "./B2BEmpresaModal.vue?vue&type=script&lang=js"
export * from "./B2BEmpresaModal.vue?vue&type=script&lang=js"
import style0 from "./B2BEmpresaModal.vue?vue&type=style&index=0&id=2ad5c80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad5c80e",
  null
  
)

export default component.exports